// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"44e23d9d","455":"f99f8f51"}[chunkId] + ".chunk.js";
};